
import { MenuBlock1, MenuBlock2, MenuBlock3, MenuBlock4 } from "../../images";

export const MenuBlock = () => {
    const menuBlockData = [
        {
            title: "Medical Staffing Solutions",
            image: MenuBlock1
        },
        {
            title: "Telemedicine Services",
            image: MenuBlock2
        },
        {
            title: "MEDEVAC Services",
            image: MenuBlock3
        },
        {
            title: "Occupational Health Services",
            image: MenuBlock4
        }
    ];

    return (
        <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {menuBlockData.map((i, index) => (
                    <div
                        key={index}
                        className="group relative overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-xl"
                    >
                        {/* Background Image */}
                        <div className="h-64 overflow-hidden">
                            <img
                                src={i.image}
                                alt={i.title}
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                            {/* Overlay - adjusted gradient for top text visibility */}
                            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-transparent" />
                        </div>

                        {/* Text Content - positioned at top */}
                        <div className="absolute top-0 left-0 right-0 p-6 text-white">
                            <h3 className="text-1xl font-bold transition-all duration-300 group-hover:translate-y-1">
                                {i.title}
                            </h3>
                        </div>

                        {/* Arrow - positioned at bottom left with animation */}
                        <div className="absolute bottom-6 left-6 w-10 h-10 bg-white rounded-full flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 -translate-x-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-800" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}